module.exports = __webpack_public_path__ + "img/ab-page2-img1.ee35a3d5.png";